import { z } from "zod";
/**
 * Баннеры состояния компании в шапке кабинета (UC1130, BR-2, контракт v2.0 §3.5, §4.4).
 * `corp_my_companies` не отдаёт `credit_state` — баннер `LIMIT` считает клиент по BR-SET-08.
 */
export const zCorpBannerKind = z.enum(["SUSPENDED", "LIMIT", "OVERDUE", "ARCHIVED"]);
export const CORP_BANNER_LABELS = {
    SUSPENDED: "Компания приостановлена",
    LIMIT: "Кредитный лимит исчерпан",
    OVERDUE: "Есть просроченные счета",
    ARCHIVED: "Компания в архиве — только просмотр",
};
